import { useNavigate } from 'react-router-dom';

/**
 * Shown instead of the recorder when this user may not record (AMP-136): in a standalone
 * practice, providers record and org admins do not.
 */
export function RecordingNotAllowed() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-blue-50/30">
      <div className="max-w-xl mx-auto px-4 py-16 text-center" role="alert">
        <h1 className="text-2xl font-semibold text-slate-800">Recording is for providers</h1>
        <p className="mt-3 text-slate-600">
          In this practice, visits are recorded by providers. Your role can book appointments and
          manage patients; ask the patient&apos;s provider to record the visit.
        </p>
        <button type="button" className="btn-primary mt-6" onClick={() => navigate('/dashboard')}>
          Back to Dashboard
        </button>
      </div>
    </div>
  );
}
